import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";
import styled from "styled-components";
import moment from "moment";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { DataContext } from "../../contexts/DataContext";
import { FiPlay } from "react-icons/fi";
import { AiOutlinePause } from "react-icons/ai";
import { Button } from "../../Theme/Hyper";
import { APIContext } from "../../contexts/APIContext";
import { useHistory, useLocation } from "react-router";
import { VizContext } from "../../contexts/VizContext";
import { ClockContext } from "../../contexts/ClockContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 40px;
`;
const Main = styled.div`
  display: flex;
  font-weight: 100;
  box-shadow: 0px 5px 3px 0 rgb(0 0 0 / 12%);
  width: 100%;
  align-items: center;
  flex-direction: column;
  margin-top: 0.5em;
  padding-bottom: 0.5em;
  z-index: 0;
  border-bottom: 1px solid #3d485d;
`;
const ClockSection = styled.div`
  display: flex;
  min-width: 70px;
  height: 90px;
  justify-content: ${(props) => (props.mins ? "flex-end" : "flex-start")};
`;
const ClockSplit = styled.div`
  height: 90px;
`;
const Half = styled.div`
  display: flex;
  font-size: 1.5em;
`;

const ClockContainer = styled.div`
  display: flex;
  font-size: 4em;
  align-items: center;
  width: 100%;
`;
const Buttons = styled.div`
  display: flex;
  width: 100%;
  padding: 0.5em;
  box-sizing: border-box;
`;
const ClockButton = styled.div`
  font-size: 2em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.green ? "#0adb93" : "#db0a41")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  /* width: 100%; */
  justify-content: center;
  margin: 0.2em;
  width: 100%;
`;

const CentrePassButton = styled.div`
  font-size: 1em;
  padding: 0.5em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.green ? "#0adb93" : "#181d25")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  /* width: 100%; */
  justify-content: center;
  margin: 0.2em;
  width: 25%;
  box-sizing: border-box;
  :hover {
    background-color: #db0a41;
  }
`;
const SSButton = styled.div`
  font-size: 1em;
  padding: 0.5em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#181d25")};

  /* width: 100%; */
  justify-content: center;
  margin: 0.2em;
  width: 100%;
  box-sizing: border-box;
  :hover {
    background-color: #db0a41;
  }
`;
const PauseResumeButton = styled(Button)`
  font-size: 0.3em;
  padding: 0.5em;
  font-weight: 100;
  margin-left: 0.5em;
  margin-right: 0.5em;
`;
const ClockDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const Row = styled.div`
  display: flex;
  width: 100%;
`;
const OnAirStatus = styled.div`
  font-size: 12px;
  padding: 0.5em 0.5em;
  border-radius: 4px;
  color: ${(props) =>
    !props.active ? "grey" : props.onAir ? "#0adb93" : "#db0a41"};
  font-weight: bold;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
`;
window.super_shot = false;
window.super_shot_flash = false;

export default function Clock({
  game,
  teams,
  previewGraphic,
  animateGraphic,
  animateOffGraphic,
  updateGraphic,
}) {
  const { vizSharedMemory, vizCommand } = useContext(VizContext);
  const { auto_clock, period } = useContext(ClockContext);
  const { homeKit, awayKit } = useContext(UIContext);
  const [ssOnMin, setSSOnMin] = useLocalStorage("netball-clock-ss-on", 3);
  const [ssFlashSecs, setSSFlashSecs] = useLocalStorage(
    "netball-clock-ss-flash",
    60,
  );
  const [centrePass, setCentrePass] = useLocalStorage("netball-centre", "none");
  const [centrePassMode, setCentrePassMode] = useLocalStorage("netball-centre-mode", "auto");
  const history = useHistory();
  const location = useLocation();
  const [clock, setClock] = useState();
  const [onAir, setOnAir] = useState(false);
  function getHalfText(number, game) {
    if (game?.number_of_periods === 2) {
      if (number === 1) {
        return "1st Half";
      } else if (number === 2) {
        return "2nd Half";
      } else if (number > 2) {
        return "ET";
      }
    } else {
      if (number === 1) {
        return "1st Q";
      } else if (number === 2) {
        return "2nd Q";
      } else if (number === 3) {
        return "3rd Q";
      } else if (number === 4) {
        return "4th Q";
      } else if (number > 4) {
        return "ET";
      }
    }
    return number;
  }

  useEffect(() => {
    // Set initial state from localStorage
    const initialState =
      localStorage.getItem("netball-clock-on-air") === "true";
    setOnAir(initialState);

    // Poll localStorage for changes
    const interval = setInterval(() => {
      const value = localStorage.getItem("netball-clock-on-air") === "true";
      setOnAir(value);
    }, 500);

    // Also listen for storage changes from other tabs
    const handleStorageChange = () => {
      const value = localStorage.getItem("netball-clock-on-air") === "true";
      setOnAir(value);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    let interval;
    let start;

    interval = setInterval(() => {
      let clock = document.getElementById("clock").innerText;
      let mins = clock.split(":")?.[0];
      let secs = clock.split(":")?.[1];

      if (
        parseInt(ssOnMin) > 0 &&
        parseInt(mins) === parseInt(ssOnMin) &&
        secs === "00"
      ) {
        start = Date.now();
        window.super_shot = true;
      } else if (
        parseInt(ssOnMin) > 0 &&
        parseInt(mins) === 0 &&
        secs === "00"
      ) {
        window.super_shot = false;
      } else if (parseInt(ssFlashSecs) > 0) {
        let start = moment.duration({ minutes: ssOnMin, seconds: 0 });
        let now = moment.duration({ minutes: mins, seconds: secs });
        let diff = start.subtract(now);
        let seconds = diff.seconds();
        if (seconds > 0 && seconds % ssFlashSecs === 0) {
          window.super_shot = true;
          window.super_shot_flash = Date.now();
        }
      }
      updateGraphic("CLOCK", {
        game: game,
        period: period,
        super_shot: window.super_shot,
        super_shot_flash: window.super_shot_flash,
      });
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, [ssOnMin, ssFlashSecs, game, period]);

  return (
    <Main>
      <Row style={{ width: "100%", marginTop: "5px" }}>
        <OnAirStatus
          onAir={onAir}
          active={!onAir}
          onClick={() => {
            localStorage.setItem("netball-clock-on-air", "false");
            setOnAir(false);
          }}
        >
          CLOCK OFF AIR
        </OnAirStatus>
        <OnAirStatus
          onAir={onAir}
          active={onAir}
          onClick={() => {
            localStorage.setItem("netball-clock-on-air", "true");
            setOnAir(true);
          }}
        >
          CLOCK ON AIR
        </OnAirStatus>
      </Row>
      {game && period && <Half>{period}</Half>}
      {/* {" "}
        {!game.actual_kick_off && (
          <Button
            green
            onClick={() => {
              updateGame({
                uuid: game.uuid,
                data: { actual_kick_off: moment().valueOf() },
              });
            }}
          >
            KICK OFF
          </Button>
        )} */}

      <ClockContainer>
        <ClockDiv>
          <ClockSection id="clock">{auto_clock}</ClockSection>
        </ClockDiv>
      </ClockContainer>

      <Column>
        <Buttons>
          <ClockButton
            onClick={() => {
              animateOffGraphic("CLOCK", {});
            }}
          >
            OUT
          </ClockButton>

          <ClockButton
            onClick={() => {
              animateGraphic("CLOCK", {
                teams: teams,
                game: game,
                clock: clock,
                period: period,
                homeKit,
                awayKit,
                centre: centrePass
              });
            }}
            green
          >
            IN
          </ClockButton>
        </Buttons>
      </Column>
      <Column style={{ justifyContent: "center", alignItems: "center" }}>
        <div>Centre pass</div>

        <Buttons style={{ justifyContent: "center", alignItems: "center" }}>
          <CentrePassButton
            green={centrePassMode === "auto"}
            style={{}}
            onClick={() => {
              setCentrePassMode("auto");
              updateGraphic("CLOCK", {
                game: game,
                period: period,
                centre_mode: "auto",
              });
            }}
          >
            AUTO
          </CentrePassButton>
          <CentrePassButton
            green={centrePassMode === "manual"}
            onClick={() => {
              setCentrePassMode("manual");
              updateGraphic("CLOCK", {
                game: game,
                period: period,
                centre_mode: "manual",
              });
            }}
          >
            MANUAL
          </CentrePassButton>
        </Buttons>
        <Buttons style={{ justifyContent: "center", alignItems: "center" }}>
          <CentrePassButton
            green={centrePass === "none"}
            style={{}}
            onClick={() => {
              setCentrePass("none");
              updateGraphic("CLOCK", {
                game: game,
                period: period,
                centre: "none",
              });
            }}
          >
            HIDE
          </CentrePassButton>
          <CentrePassButton
            green={centrePass === "home"}
            style={{}}
            onClick={() => {
              setCentrePass("home");
              // updateGraphic("CLOCK", {
              //   game: game,
              //   period: period,
              //   centre: "home",
              // });
            }}
          >
            HOME
          </CentrePassButton>
          <CentrePassButton
            green={centrePass === "away"}
            onClick={() => {
              setCentrePass("away");
              // updateGraphic("CLOCK", {
              //   game: game,
              //   period: period,
              //   centre: "away",
              // });
            }}
          >
            AWAY
          </CentrePassButton>
       
        </Buttons>
        <Buttons>
              <CentrePassButton
            style={{width: '100%'}}
            onClick={() => {

                vizCommand({
                  viz_command:
                    '10 FRONT_SCENE*TREE*$ClockScript*SCRIPT INVOKE flipCP'
                });

              // updateGraphic("CLOCK", {
              //   game: game,
              //   period: period,
              //   centre: "home",
              // });
            }}
          >
            FLIP CP
          </CentrePassButton>
        </Buttons>
        <Buttons>
          <Row>
            <SSButton
              onClick={() => {
                window.super_shot = true;
              }}
              green
            >
              SS ON
            </SSButton>
            <SSButton
              onClick={() => {
                window.super_shot = false;
              }}
              green
            >
              SS OFF
            </SSButton>
          </Row>
          <Column>
            <span>Trigger on</span>
            <Row>
              <Input
                value={ssOnMin}
                onChange={(e) => {
                  setSSOnMin(e.currentTarget.value);
                }}
              />
              min
            </Row>
          </Column>
        </Buttons>
        <Buttons>
          <CentrePassButton
            onClick={() => {
              window.super_shot_flash = Date.now();
            }}
          >
            FLASH
          </CentrePassButton>
          <Column>
            <span>Flash every</span>
            <Row>
              <Input
                value={ssFlashSecs}
                onChange={(e) => {
                  setSSFlashSecs(e.currentTarget.value);
                }}
              />
              secs
            </Row>
          </Column>
        </Buttons>
      </Column>
    </Main>
  );
}
